/**
 * API paths for Portal Platform endpoints.
 * These paths are handled by the Content Hub Memberships system.
 */

// Authentication endpoints
export const LOGOUT_PATH = '/_hcms/mem/logout';

// Portal data endpoint
export const PORTAL_DATA_PATH = '/_hcms/portal-backend/v1/portal-data';

// Deal plans endpoints
export const BUYER_LOGO_PATH = '/_hcms/deal-plans/v1/buyer-logo';